/**
 * Personal integrations: connect your own accounts so Delivery Hub can reach you where
 * you already are. Each one is a card here rather than its own place in the nav, so
 * adding the next integration means adding a card, not a new top-level surface.
 */

import { Link } from "react-router-dom";

import { endpoints } from "@/api/endpoints";
import { Badge } from "@/components/ui";
import { useAsync } from "@/hooks/useAsync";

function TeamsCard() {
  const { data: connection, loading } = useAsync(() => endpoints.teamsConnection(), []);

  return (
    <Link to="/account/apps/teams" className="card">
      <div className="card__body">
        <div className="row row--between" style={{ marginBottom: 6 }}>
          <h2 className="truncate">Microsoft Teams</h2>
          {!loading && connection?.connected && (
            <Badge tone={connection.needs_reconnect ? "danger" : "accent"}>
              {connection.needs_reconnect ? "Needs reconnecting" : "Connected"}
            </Badge>
          )}
        </div>

        <div className="muted" style={{ minHeight: 38, fontSize: 13 }}>
          Get a Teams message in your own chats or channels when your runs finish.
        </div>
      </div>
    </Link>
  );
}

export function Apps() {
  return (
    <>
      <div className="page-header">
        <div>
          <h1>Apps</h1>
          <div className="page-header__meta">
            Connect your own accounts so Delivery Hub can reach you where you already are
          </div>
        </div>
      </div>

      <div className="grid-cards">
        <TeamsCard />
      </div>
    </>
  );
}
